import { useState, useCallback } from "react";

/**
 * Shared state controller for service modals
 * Ensures only one modal instance exists in DOM at a time
 */
export const useServiceModal = () => {
  const [activeServiceId, setActiveServiceId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openServiceModal = useCallback((serviceId) => {
    setActiveServiceId(serviceId);
    setIsOpen(true);
  }, []);

  const closeServiceModal = useCallback(() => {
    setIsOpen(false);
    // Delay clearing the service ID to allow closing animation
    setTimeout(() => {
      setActiveServiceId(null);
    }, 200);
  }, []);

  return {
    activeServiceId,
    isOpen,
    openServiceModal,
    closeServiceModal
  };
};

export default useServiceModal;
